import { ANY_PROFESSION_ID } from "components/SelectProfessionExtended";
import useGlobalContext from "hooks/globalData";
import { useStrictQuery } from "hooks/useStrictQuery";
import { useIntl } from "react-intl";
import {
  ListRequestOfSkuQualificationFilter,
  Profession,
  SkuQualificationFilter,
} from "services/KnowfullyAdminClient";
import contextStore from "stores/contextStore";
import persistanceStore from "stores/persistanceStore";

export const useSkuQualificationsQuery = (
  skuId: string,
  order: "asc" | "desc",
  orderBy: string,
) => {
  const { skuService } = useGlobalContext();
  const { formatMessage: t } = useIntl();

  const qualificationId = persistanceStore.useState((s) => s.qualificationId);
  const stateId = persistanceStore.useState((s) => s.stateId);
  const professionId = persistanceStore.useState((s) => s.professionId);
  const creditSubmissionExpirationDateFrom = persistanceStore.useState(
    (s) => s.creditSubmissionExpirationDateFrom
  );
  const creditSubmissionExpirationDateTo = persistanceStore.useState(
    (s) => s.creditSubmissionExpirationDateTo
  );

  const organizationId = contextStore.useState((s) => s.organizationId);

  return useStrictQuery(
    [
      "skuQualifications",
      skuId,
      qualificationId,
      stateId,
      professionId,
      creditSubmissionExpirationDateFrom,
      creditSubmissionExpirationDateTo,
      order,
      orderBy,
      organizationId
    ],
    () =>
      skuService.getSkuQualifications(
        skuId,
        ListRequestOfSkuQualificationFilter.fromJS({
          sortField: orderBy,
          sortDescending: order === "desc",
          pageSize: -1,
          parameters: SkuQualificationFilter.fromJS({
            qualificationId,
            stateId,
            professionId,
            creditSubmissionExpirationDateFrom,
            creditSubmissionExpirationDateTo,
          }),
        })
      ),
    {
      onSuccess: (data) => {
        if (data?.data) {
          for (let skuQualification of data.data) {
            skuQualification.profession ??= new Profession({
              id: ANY_PROFESSION_ID,
              name: t({ id: "anyLabel" }),
            });
          }
        }
      },
    }
  );
};
